import { createApp } from 'vue';
import VueTheMask from 'vue-the-mask';
import App from './App.vue';
import "./assets/scss/globals.scss";
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';

import '@mdi/font/css/materialdesignicons.css';

const app = createApp(App);

app.use(router);
app.use(store);
app.use(VueTheMask);
app.use(vuetify);
app.mount('#app');